import { SIDE_BAR_LIMIT } from "config/appConfig";
import { GetWorkOrders } from "hooks/apollo/workOrder/workOrder.gql";
import filter from "lodash/filter";

function insertWorkOrder(newWorkOrder, proxy) {
  const currentWorkOrders = read(proxy);

  const updatedWorkOrders = [newWorkOrder].concat(filter(currentWorkOrders, (wo) => wo.id !== newWorkOrder.id));

  write(updatedWorkOrders, proxy);
}

function removeWorkOrder(workOrderId, proxy) {
  const currentWorkOrders = read(proxy);

  const updatedWorkOrders = currentWorkOrders.filter((workOrder) => workOrder.id !== workOrderId);

  write(updatedWorkOrders, proxy);
}

function read(proxy) {
  const { workOrders } = proxy.readQuery({
    query: GetWorkOrders,
    variables: { limit: SIDE_BAR_LIMIT },
  });

  return workOrders;
}

function write(workOrders, proxy) {
  proxy.writeQuery({
    data: { workOrders },
    query: GetWorkOrders,
    variables: { limit: SIDE_BAR_LIMIT },
  });
}

export { insertWorkOrder, removeWorkOrder };
